import React from 'react';
import EventContent from '../content/EventContent';
import {useEvent} from '../../../api/hooks';
import Loader from '../Loader';
import PageNotFound from '../PageNotFound';
import Error from '../Error';

export const EventSelector = ({match, children}) => {
    const {data: event, isLoading, error} = useEvent(match.params.id, {
        // Don't embed event dates in the response, we load them separately
        include_event_dates: false,
    });

    if (isLoading) {
        return <Loader />;
    }

    if (error) {
        return <Error errors={[error]} />;
    }

    return children({event});
};

const Event = ({match}) => (
    <EventSelector match={match}>
        {({event}) => (
            <>
                {event.error || event.code ? <PageNotFound error={event} />
                    :
                    <>
                        <EventContent event={event} />
                    </>
                }
            </>
        )}
    </EventSelector>
);

export default Event;
